import {instance, onErrorFunction} from "../../../config/axios-cnf";


export const apiGetTariffList = (subjectId, callback, error) => {
    instance.get(`/api/v2/subject-test/tariff`,{params:{subjectId}})
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiGetEventList = (subjectId, callback, error) => {
    instance.get(`/api/v2/subject-test/events`,{params:{subjectId}})
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiGetEntrances = (eventId, getFromSystem, sendToEnigoo, sendToSlack, callback, error) => {
    instance.get(`/api/v2/subject-test/events/get-entrances`,{params:{eventId, getFromSystem, sendToEnigoo, sendToSlack}})
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}
